import React, { Component } from 'react';
import AntBadge, { BadgeProps as AntBadgeProps } from 'antd/lib/badge';

import styles from './Badge.module.scss';

interface BadgeProps extends AntBadgeProps {}

class Badge extends Component<BadgeProps> {
	render() {
		return <AntBadge {...this.props} className={styles.badge} />;
	}
}

export default Badge;
